export default __webpack_public_path__ + "4a716a149d8f3159dcebaead92ed1046.png";